/** The commander's session (from signing in with Discord, `/auth/`): kept
 *  in local storage, handed to the live world when joining a side. */

const KEY = "ferro-session";

export function session(): string {
  try {
    return localStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
}

export function setSession(s: string | null): void {
  try {
    if (s) localStorage.setItem(KEY, s);
    else localStorage.removeItem(KEY);
  } catch {
    /* this visit only */
  }
}

/** Takes a session the sign-in sent back in the address's fragment
 *  (`#session=...`), or the reason it failed (`#signin=...`); clears it. */
export function takeFromAddress(): string | null {
  const m = location.hash.match(/^#(session|signin)=([\w-]+)$/);
  if (!m) return null;
  history.replaceState(null, "", location.pathname + location.search);
  if (m[1] === "session") {
    setSession(m[2]);
    return null;
  }
  return m[2] === "expired" ? "Sign-in took too long; try again." : m[2] === "cancelled" ? "Sign-in was cancelled." : "Sign-in failed; try again.";
}

export interface Me {
  name: string;
  /** The faction they command, if any. */
  side: number | null;
  /** Their Discord avatar's image address. */
  avatar: string | null;
}

/** Who the session belongs to (null: not signed in). */
export async function whoAmI(): Promise<Me | null> {
  const s = session();
  if (!s) return null;
  try {
    const res = await fetch(`auth/me?session=${encodeURIComponent(s)}`, { cache: "no-store" });
    const v = (await res.json()) as { name: string | null; side: number | null; avatar?: string };
    return v.name ? { name: v.name, side: v.side, avatar: v.avatar ?? null } : null;
  } catch {
    return null;
  }
}
